<template>
  <div style="width: 1400px; margin:0 auto;">

    <h1>Liste des commandes</h1>
    <h2 style="margin-bottom: 50px;">{{ orderCount }} commandes</h2>
    <b-button variant="outline-primary" v-on:click="update()" style="margin-bottom: 50px; margin-top: 20px; margin-left: 35px;">Mise à jour du catalogue</b-button>
    <!--<p style="text-align: center; padding-left: 0; margin-bottom: 40px;">Toutes marques, tous pays, toutes sales team confondues</p>-->

    <div class="accordion" role="tablist">
            <div v-for="(order, index) in tabQuotations" v-bind:key="order">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle="'accordion-'+index" variant="info">
                  {{ order.date }} - {{ order.customer_name }}{{ order.organization_name }} - {{ order.salesman_name }}
                  <p v-if="order.odoo_id == 'Non synchronisé - Erreur'" style="color: red; padding-left: 0px;">Pas synchronisé avec Odoo</p>
                  <p v-if="order.odoo_id != 'Non synchronisé - Erreur'" style="color: green; padding-left: 0px;">Odoo order id : {{ order.odoo_id }}</p>
                </b-button>
              </b-card-header>
              <b-collapse :id="'accordion-'+index" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>
                    <p>Date : {{ order.date }}</p>
                    <p>Id: {{ order.id }}</p>
                    <p>Odoo order id : {{ order.odoo_id }}</p>
                    <p>SE : {{ order.salesman_name }}</p>
                    <p>Client : {{ order.customer_name }}{{ order.organization_name }}</p>
                    <!--<p>Erreur : </p>-->
                    <b-button variant="outline-primary" v-on:click="submit(order.id)" style="margin-bottom: 50px; margin-top: 20px; margin-left: 35px;">Relancer la synchronisation</b-button>
                    <b-button variant="outline-danger" v-on:click="deleteQuot(order.id)" style="margin-bottom: 50px; margin-top: 20px; margin-left: 35px;">Supprimer</b-button>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            </div>
          </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabQuotations : [],
      orderCount : "",
      erreur: "",
      showError: false,
    }
  },
  methods: {
    submit(id) {
      // /quotations/:id/push
      // prod https://saddle-expert.equisenseapi.com/quotations/
      // staging "https://voltaire.equisenseapi.com/"
      let proxyurl = ""; //"https://frontapp-observablehq.herokuapp.com/";
      let urlQuotations = "https://saddle-expert.equisenseapi.com/quotations/" + id + "/push";
      let token = localStorage.getItem('tokenId');

      var optionsSearch = {
        'method' : 'POST',
        'headers': {'Authorization':token}
      };

      fetch(proxyurl + urlQuotations, optionsSearch)
          .then(res => res.json())
            .then(json => {
              alert('La requête a bien été postée');
            })
            .catch(err => {
              alert('Erreur: ', err);
              this.erreur = err;
              this.showError = true;
            });
    },
    deleteQuot(id) {
      // /quotations/:id
      let proxyurl = ""; //"https://frontapp-observablehq.herokuapp.com/";
      let urlQuotations = "https://saddle-expert.equisenseapi.com/quotations/" + id; // prod https://saddle-expert.equisenseapi.com/quotations/
      let token = localStorage.getItem('tokenId');

      var optionsSearch = {
        'method' : 'DELETE',
        'headers': {'Authorization':token}
      };

      fetch(proxyurl + urlQuotations, optionsSearch)
          .then(res => res.json())
            .then(json => {
              alert('La quotation a bien été effacée');
            })
            .catch(err => {
              alert('Erreur: ', err);
              this.erreur = err;
              this.showError = true;
            });
    },
    update() {
      // /quotations/update/products
      let proxyurl = "https://frontapp-observablehq.herokuapp.com/";
      let urlQuotations = "https://saddle-expert.equisenseapi.com/update/products/"; // staging : "https://voltaire.equisenseapi.com/update/products/"
      let token = localStorage.getItem('tokenId');

      var optionsSearch = {
        'method' : 'GET',
        'headers': {'Authorization':token}
      };

      fetch(proxyurl + urlQuotations, optionsSearch)
          .then(res => res.json())
            .then(json => {
              alert('La mise à jour est faite');
            })
            .catch(err => {
              alert('Erreur: ', err);
              this.erreur = err;
              this.showError = true;
            });
    }
  },
  beforeCreate() {
    let proxyurl = ""; //"https://frontapp-observablehq.herokuapp.com/";
    let urlQuotations = "https://saddle-expert.equisenseapi.com/quotations?full=true";
    let urlCustomers = "https://saddle-expert.equisenseapi.com/customers?full=true";
    let urlSalesteam = "https://saddle-expert.equisenseapi.com/salesteam?full=true";
    let urlSalesmen = "https://saddle-expert.equisenseapi.com/salesmen?full=true";
    let urlOrganizations = "https://saddle-expert.equisenseapi.com/organizations?full=true";

    let token = localStorage.getItem('tokenId');

    var optionsSearch = {
      'method' : 'GET',
      'headers': {'Authorization':token}
    };

    fetch(proxyurl + urlQuotations, optionsSearch)
          .then(res => res.json())
            .then(json => {
              for (let i=0; i<json.length; i++) { 

                if (json[i].customer_id == undefined) {
                  json[i].customer_id = "";
                }

                if (json[i].organization_id == undefined) {
                  json[i].organization_id = "";
                }

                let object = {
                  "id": json[i].id,
                  "customer_id": json[i].customer_id,
                  "customer_name" : "",
                  "organization_id": json[i].organization_id,
                  "organization_name" : "",
                  "salesteam_id": json[i].salesteam_id,
                  "salesteam_name" : "",
                  "salesman_id": json[i].salesman_id,
                  "salesman_name" : "",
                  "date": (new Date(json[i].date * 1000)).toLocaleDateString(),
                  "sort": json[i].date,
                  "odoo_id": json[i].odoo_id
                }
                this.tabQuotations.push(object);
              }
              this.orderCount = this.tabQuotations.length;
              //console.log("tabQuotations: ", this.tabQuotations);
              
              // tri du tableau par date
              this.tabQuotations.sort(function (a, b) {
                return b.sort - a.sort;
              });

              // on remplit le statut Odoo
              for (let a=0; a<this.tabQuotations.length; a++) {
                if (this.tabQuotations[a].odoo_id == null) {
                  this.tabQuotations[a].odoo_id = "Non synchronisé - Erreur";
                }
              }
              

              // on va chercher les correspondances ids / noms clients
              fetch(proxyurl + urlCustomers, optionsSearch)
                .then(res => res.json())
                .then(json => {
                  for (let j=0; j<json.length; j++) {
                    for (let k=0; k<this.tabQuotations.length; k++) {
                      if (json[j].id == this.tabQuotations[k].customer_id) {
                        this.tabQuotations[k].customer_name = json[j].name;
                      }
                    }
                  }
                  //console.log('Quotations avec clients: ', this.tabQuotations);

                  // on va chercher les correspondances ids / noms organizations
                  fetch(proxyurl + urlOrganizations, optionsSearch)
                    .then(res => res.json())
                    .then(json => {
                      for (let l=0; l<json.length; l++) {
                        for (let m=0; m<this.tabQuotations.length; m++) {
                          if (json[l].id == this.tabQuotations[m].organization_id) {
                            this.tabQuotations[m].organization_name = json[l].name;
                          }
                        }
                      }
                      //console.log('Quotations avec organizations: ', this.tabQuotations);
                    })

                    // on va chercher les correspondances ids / noms sales teams
                    fetch(proxyurl + urlSalesteam, optionsSearch)
                      .then(res => res.json())
                      .then(json => {
                        for (let n=0; n<json.length; n++) {
                          for (let o=0; o<this.tabQuotations.length; o++) {
                            if (json[n].id == this.tabQuotations[o].salesteam_id) {
                            this.tabQuotations[o].salesteam_name = json[n].name;
                            console.log('sales team: ', json[n].id + " / " + json[n].name);
                            }
                          }
                        }
                        //console.log('Quotations avec sales teams: ', this.tabQuotations);
                      })

                      // on va chercher les correspondances ids / noms SE
                      fetch(proxyurl + urlSalesmen, optionsSearch)
                        .then(res => res.json())
                        .then(json => {
                          for (let p=0; p<json.length; p++) {
                            for (let q=0; q<this.tabQuotations.length; q++) {
                              if (json[p].id == this.tabQuotations[q].salesman_id) {
                              this.tabQuotations[q].salesman_name = json[p].name;
                              }
                            }
                          }
                        })
                  })
              // aller chercher lien commande Odoo ici
            })
  }
};
</script>

